import React from 'react';
var ModaleTitre = function (_a) {
    var idModale = _a.idModale, children = _a.children;
    return (React.createElement("h1", { id: "fr-modal-title-".concat(idModale), className: "fr-modal__title" }, children));
};
export default ModaleTitre;
